const anos =  [
    { value: "Planta", label: "Planta" },
    { value: "Construção", label: "Construção" },
    { value: "Pronto", label: "Pronto" },
];

module.exports = anos;